import { render } from "./NotFound.vue?vue&type=template&id=52a6b0d4"
const script = {}

import exportComponent from "/Users/lgorden/git/Fybr/parking-manager-sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__